module.exports = __webpack_public_path__ + "static/media/whatsapp.43e1ea1c.svg";